import React, { FunctionComponent } from "react";
import { RouteProps, useNavigate } from "react-router-dom";
import { MENU_ITEMS_USER } from "constants/menu/menu";
import { authService } from "services/auth/AuthService";
import { useAuthUser } from "hooks/useAuthUser";
import { LOGIN_PATH } from "constants/routes/RoutePaths";
import { useChangeContext } from "constants/context/ChangeContext";
import { useUserContext } from "constants/context/UserContext";
import { MenuItem } from "interfaces/menu/menu";
import { LanguageDropdown } from "components/molecules/menu/LanguageDropdown";
import { SideMenuItem } from "components/molecules/menu/SideMenu/SideMenuItem";
import { ExitToApp } from "@mui/icons-material";
import { MenuList } from "@mui/material";

interface SideMenuUserItemsProps extends RouteProps {
    mobile: boolean;
    reduce: boolean;
    mobileMenuOpen: boolean;
    onCloseMobileMenu: () => void;
    selectedItem: MenuItem;
    selectedSubItem: MenuItem;
    onSelectMenuItem: (item:MenuItem) => void;
    subMenuOpen: boolean;
}

const SideMenuUserItems: FunctionComponent<SideMenuUserItemsProps> = ({
    mobile,
    mobileMenuOpen,
    reduce,
    onCloseMobileMenu,
    selectedItem,
    selectedSubItem,
    onSelectMenuItem,
    subMenuOpen,
}) => {

    const { setUnsaveChange } = useChangeContext();
    const { setUser, setPermissions } = useUserContext();
    const { user } = useAuthUser();
    const navigate = useNavigate();

    const handleUserMenuOnClick = () => {
        onSelectMenuItem;
        setUnsaveChange(false);
        setUser(null);
        setPermissions([]);
        authService.logout();
        navigate(LOGIN_PATH);

    }

    const item:MenuItem = {
        href: undefined,
        Icon: undefined, 
        label: "log_out",
    };

    return (
        <>
            {!!user &&
                <MenuList sx={{ padding: 0 }}>
                    {MENU_ITEMS_USER.map((item, i) =>
                        <SideMenuItem
                            key={i}
                            icon={<item.Icon fontSize="small" />}
                            item={item}
                            userMenuLabel={item.label === "menu_my_account"}
                            user={user}
                            reduce={reduce}
                            selectedItem={selectedItem}
                            selectedSubItem={selectedSubItem}
                            onSelectMenuItem={onSelectMenuItem}
                            mobileMenuOpen={mobileMenuOpen}
                            onCloseMobileMenu={onCloseMobileMenu}
                            subMenuOpen={subMenuOpen}
                        />

                    )}

                    {mobile && mobileMenuOpen &&
                        <LanguageDropdown
                            mobile={true}
                            mobileMenuOpen={mobileMenuOpen}
                            onCloseMobileMenu={onCloseMobileMenu}
                            selectedItem={selectedItem}
                            selectedSubItem={selectedSubItem}
                            onSelectMenuItem={onSelectMenuItem}
                            subMenuOpen={subMenuOpen}
                        />
                    }

                    <SideMenuItem
                        icon={<ExitToApp fontSize="small" />}
                        reduce={reduce}
                        user={user}
                        onSelectMenuItem={handleUserMenuOnClick}
                        selectedItem={selectedItem}
                        selectedSubItem={selectedSubItem}
                        item={item}
                        mobileMenuOpen={mobileMenuOpen}
                        onCloseMobileMenu={onCloseMobileMenu}
                        subMenuOpen={subMenuOpen}
                    />
                </MenuList>
            }
        </>
    )
}

export default SideMenuUserItems;
